import { Box, FormControl, InputLabel, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import { ArrowDropDownIcon, DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import React, { useEffect, useState } from 'react'
import { ApiStarRatingPerformance } from '../../apiService/Core/Apicall';
import { toast } from 'react-toastify';
import Domains from '../../global/constants/domain';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../global/config/store';
import { setSelectedMonth } from '../../global/config/Reducer/MonthSlice';
import storage from '../../utils/storage';


const getIconColorByDomain = () => {
    const domain = window.location.hostname;

    if (domain.includes(Domains.ALDI)) return '#001F79';
    if (domain.includes(Domains.BLOOMS)) return '#1C2B90';
    if (domain.includes(Domains.MM)) return '#ADB792';

    return '#ADB792';
};
const primary_color = getIconColorByDomain()

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: primary_color,
        color: theme.palette.common.white,
        padding: "10px 20px"
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        padding: " 10px 20px",
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(even)': {
        backgroundColor: `${primary_color}1A`,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));




function MonthlyReport() {
    const selectedMonth = useSelector((state: RootState) => state.month.selectedMonth)
    const dispatch = useDispatch()
    const [month, setmonth] = useState<any>(dayjs(selectedMonth))
    const [starratingperformance, setstarratingperformance] = useState<any>([])
    const clientEntity = useSelector((state: RootState) => state.clientEntity.selectedEntity)


    useEffect(() => {
        const getData = async () => {
            const data = `?year=${month.year()}&month=${month.month() + 1}&clientEntityId=${storage.getItem('clientEntityId')}&isClientEntityIdRequired=true${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`
            try {
                const response = await ApiStarRatingPerformance(data)
                setstarratingperformance(response.data)

            } catch (error: any) {
                // toast.error(error)
            }

        }
        getData()
    }, [month, clientEntity])

    useEffect(() => {
        setmonth(dayjs(selectedMonth))
    }, [selectedMonth])
    return (
        <Box className='mt-3'>
            <Box className='d-flex align-items-center justify-content-end'>
                <FormControl sx={{ width: { xs: "31%", md: '9%' } }}>
                    {/* <InputLabel id="demo-simple-select-label" shrink={false}>Select Months <span className='text-danger'>*</span></InputLabel> */}
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker value={month} className=''
                            views={['month', 'year']}
                            format="MMM-YY"
                            onChange={(e: any) => {
                                const isoString = e?.startOf('month').toISOString();
                                dispatch(setSelectedMonth(isoString));
                            }}
                            slots={{
                                openPickerIcon: ArrowDropDownIcon,
                            }}
                        />
                    </LocalizationProvider>
                </FormControl>
            </Box>
            <Box>
                <Typography variant='h4' className='text-center fw-bold text-main'>Overall Score: {starratingperformance?.overallScore ?? 'N/A'}/5</Typography>
            </Box>
            {/* ----------------------------------------------------- Group Report ----------------------------- */}
            <Box className='table'>
                <Typography className='fw-bold my-2' variant='h6'>Star Rating Performance Report- Group</Typography>
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 700, width: '100%' }} aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>Venue Name</StyledTableCell>
                                {starratingperformance?.categoryReport?.map((item: any, index: number) => (
                                    <StyledTableCell key={index} align='center'>{item?.categoryName}</StyledTableCell>
                                ))}
                                <StyledTableCell align='center'>Average Score</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {((starratingperformance?.starRatingPerformanceReport)?.length) > 0 ? (starratingperformance?.starRatingPerformanceReport?.map((item: any, index: number) => (
                                <StyledTableRow key={index}>
                                    <StyledTableCell key={index}>{item?.venueName}</StyledTableCell>
                                    {starratingperformance?.categoryReport?.map((categories: any, index: number) => {
                                        const matchedCategory = item?.categories.find(
                                            (category: any) => category.categoryName === categories?.categoryName
                                        );

                                        return (
                                            <StyledTableCell align="center" key={index}>
                                                {matchedCategory ? matchedCategory.categoryScore : "-"}
                                            </StyledTableCell>
                                        );
                                    })}
                                    <StyledTableCell align='center' style={{ borderLeft: '1px solid black' }}>{item?.averageScore}</StyledTableCell>

                                </StyledTableRow>
                            ))) : <StyledTableCell align='center' colSpan={2} ><Typography className='mx-auto text-center' variant='h5'>No Data Found</Typography></StyledTableCell>}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>

            {/* ------------------------------------------------- Cateory Report --------------------------------------------- */}

            <Box className='mt-5'>
                <Typography className='fw-bold my-2' variant='h6'> Category Report</Typography>
                <Box className='d-flex align-items-start gap-1 flex-wrap'>
                    {((starratingperformance?.categoryReport)?.length) > 0 ? (starratingperformance?.categoryReport?.map((item: any, index: any) => (
                        <Box className='table' sx={{ width: { xs: '100%', md: '33%' } }}>
                            <TableContainer component={Paper}>
                                <Table aria-label="customized table">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell colSpan={2}>{item?.categoryName}</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {item?.venues?.map((venue: any, index: number) => (
                                            <StyledTableRow key={index}>
                                                <StyledTableCell component="th">
                                                    {venue?.venueName}
                                                </StyledTableCell>
                                                <StyledTableCell align="center">{venue?.score}</StyledTableCell>
                                            </StyledTableRow>
                                        ))}

                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    ))) : <Typography className='text-center w-100 my-3' variant='h5'>No Data Found</Typography>}

                </Box>

            </Box>
        </Box>

    )
}

export default MonthlyReport
